import BaseUI from '../../../../component/baseui';
import tpl from './tpl.html';
import util from '../../../../lib/util.js';
import { getTranslation } from '../../../../utils';

import './style.scss';

const clickType = util.click();
let app = null;

function bindEvents(data, $node) {
  $node.find('#J_ShowMore').on(clickType, () => {
    const $rarSlideUpNode = window.rarSlideUpNode;
    if ($rarSlideUpNode) {
      $rarSlideUpNode.find('.J_Mask').show().parent().removeClass('slide-out-to-bottom');
      $rarSlideUpNode.show();
    }
  });
  $node.find('#J_ShowDetails').on(clickType, e => app.util.openWindow(e.currentTarget.dataset.url));
}

export default function rarCard(data) {
  app = this;
  const feedbackAction = data.action;

  const params = {
    name: 'rar_detail',
    mid: data.mid,
    content: tpl.render({
      ...data,
      refundAmountText: getTranslation('csc.bot.rar.refund_amount'),
      returnReasonText: getTranslation('csc.bot.rar.return_reason'),
      viewDetailText: getTranslation('csc.btn.view_detail'),
      showMoreText: getTranslation('csc.btn.rar.show_more'),
    }),
    title: getTranslation('csc.bot.rar.card_title'),
  };

  const $node = $(BaseUI.panelMsg(params));

  bindEvents(data, $node);
  app.view.footer.submit({ q: 'feedback', ext: { botJson: JSON.stringify(feedbackAction) } }, 'text', false, true);

  return {
    // 插件返回的结果
    body: $node,
    // 插件调用ready后的回调
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/rar/card/index.js